import { useTranslation } from 'react-i18next';

import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import InfoListItem from '~/components/InfoListItem';
import useDataCenter from '~/hooks/useDataCenter';

const RegionAccessInfo = () => {
  const { t } = useTranslation('site', {
    keyPrefix: 'dcCenter',
  });
  const { isPending, dCName, dCType } = useDataCenter();

  if (dCType !== 'oci') return null;

  return (
    <InfoListItem title={t('title')} tooltipText={t('locationInfo')}>
      {/* While loading */}
      {isPending && (
        <Stack direction="row" spacing={1}>
          <Skeleton width={185} height={24} />
          <Skeleton width={64} height={24} />
        </Stack>
      )}

      <Typography
        sx={{ wordBreak: 'break-all' }}
        variant="h4"
        data-testid="region-access-info"
      >
        {dCName}
      </Typography>
    </InfoListItem>
  );
};

export default RegionAccessInfo;
